// src/hooks/useLoginMutation.ts
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { fetcher, requestHandler } from './useApi';
import { useContextValue } from '../Context';
import { User } from '../models/user.model';

interface LoginData {
  username: string;
  password: string;
}

// Exchanges credentials for a session token; the password is never stored.
export const login = async (values: LoginData): Promise<User> => {
  localStorage.removeItem('token');
  const { token } = await requestHandler<{ token: string }, LoginData>(
    'post',
    '/v1/public/login',
    values
  );
  localStorage.setItem('token', token);
  return fetcher<User>('/v1/auth/me');
};

export const useLoginMutation = () => {
  const { setState } = useContextValue();

  return useMutation<User, AxiosError<{ message?: string }>, LoginData>(login, {
    onSuccess: (data) => {
      localStorage.setItem('user', JSON.stringify(data));
      setState((prevState) => ({ ...prevState, user: data }));
    },
    onError: () => {
      localStorage.removeItem('token');
    },
  });
};
